import { render, staticRenderFns } from "./NewSms.vue?vue&type=template&id=1389dd5a&scoped=true"
import script from "./NewSms.vue?vue&type=script&lang=js"
export * from "./NewSms.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NewSms.vue?vue&type=style&index=1&id=1389dd5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389dd5a",
  null
  
)

export default component.exports